export function footnotes(words: string[], shortFunction: (word: string) => string) {
  const result: string[] = [];
  for (const word of words) {
    const short = shortFunction(word);
    if (short && short !== word) {
      result.push(`${short}=${word}`);
    }
  }
  return result.join(', ');
}